<template>
  <header class="ew-page-header">
    <div class="ew-page-header-text">
      <h1 class="ew-page-title">{{ title }}</h1>
      <p v-if="subtitle" class="ew-page-subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.default" class="ew-page-actions">
      <slot></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' }
  }
}
</script>

<style scoped>
.ew-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin: 8px 0 20px;
}

.ew-page-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/PageHeader.vue